import { MY_DAY_CONFIRMATION_KEY } from '../../../common/constants';
import { deepCopy } from '../utils';

const STEP_LABELS = {
	[MY_DAY_CONFIRMATION_KEY.RUN_OVERVIEW]: 'Run overview',
	[MY_DAY_CONFIRMATION_KEY.TUBS_LOADED]: 'Tubs loaded',
	[MY_DAY_CONFIRMATION_KEY.ACCESS_KEYS]: 'Keys and site access',
	[MY_DAY_CONFIRMATION_KEY.TICKETS_SUMMARY]: 'Tickets summary',
	[MY_DAY_CONFIRMATION_KEY.SERVICE_RUN_STARTED]: 'Start service run',
	[MY_DAY_CONFIRMATION_KEY.BRIEF_READ]: 'Run brief read',
	[MY_DAY_CONFIRMATION_KEY.MONEY_BAGS]: 'Money bags return',
	[MY_DAY_CONFIRMATION_KEY.RETURN_KEYS]: 'Return keys and access passes',
	[MY_DAY_CONFIRMATION_KEY.RETURN_STOCK]: 'Return stock',
};

/**
 * Offline operation config for the My day step confirmation mutation.
 *
 * The server-side mutation is idempotent per step key (guarded $push), so a
 * queued confirmation can be replayed safely. The optimistic update appends
 * the confirmation to the cached run so the guided board advances offline.
 */
const confirmMyDayStepConfig = {
	serializeVariables: ({ variables }) => deepCopy(variables),
	createMeta: ({ variables }) => ({
		type: 'confirmMyDayStep',
		serviceRunId: variables?.id,
		stepKey: variables?.stepKey,
		stepLabel: STEP_LABELS[variables?.stepKey] || null,
	}),
	applyOptimisticUpdate: async ({ client, variables }) => {
		const cacheId = client.cache.identify({
			__typename: 'ServiceRun',
			id: variables.id,
		});

		if (!cacheId) {
			return;
		}

		client.cache.modify({
			id: cacheId,
			fields: {
				myDayConfirmations: (existingConfirmations = []) => {
					const alreadyConfirmed = existingConfirmations.some(confirmation => confirmation?.key === variables.stepKey);
					if (alreadyConfirmed) {
						return existingConfirmations;
					}

					return [
						...existingConfirmations,
						{
							__typename: 'ServiceRunMyDayConfirmation',
							key: variables.stepKey,
							at: new Date().toISOString(),
							items: variables.items || null,
						},
					];
				},
			},
		});
	},
	getOfflineResult: ({ variables, queueEntry }) => ({
		confirmMyDayStep: {
			__typename: 'ServiceRun',
			id: variables.id,
			offlineQueuedAt: queueEntry.createdAt,
			offline: true,
		},
	}),
};

export default confirmMyDayStepConfig;
